<template>
  <div>
    <FormSection title="Sponsorships & Tickets">
      <div>
        <div
          class="teach-styled styled-radio-container styled-radio-container--ou-donation row"
        >
          <div v-for="[amount, description] of amounts" :key="amount" class="amount-row">
            <input
              :id="`amount${amount}`"
              type="radio"
              class="amount"
              @click="(selectedAmount = amount), setValue('custom.preK', 'no')"
              :checked="selectedAmount == amount"
            />
            <FormLabel :for="`amount${amount}`">
              <div class="label__wrapper" v-html="description"></div>
            </FormLabel>
          </div>
          <div class="amount-row amount-row--wide">
            <input
              id="ticketsingle"
              type="radio"
              class="amount"
              @click="(selectedAmount = 250), setValue('custom.preK', 'no')"
              :checked="selectedAmount == 250 && getValue('custom.preK') !== 'journal'"
            />
            <FormLabel for="ticketsingle">
              <div class="label__wrapper">
                $250 - Per ticket <span style="font-size: 14px">OR</span> Journal Entry
                NOT ATTENDING DINNER
              </div>
            </FormLabel>
          </div>
          <div class="amount_other__wrapper amount-row">
            <input
              id="amount_other_check"
              type="radio"
              class="amount"
              :checked="customSelected"
              @click="customSelected = true"
            />
            <input
              id="amount_other"
              type="number"
              min="1"
              name="amount_other"
              placeholder="Other"
              v-model="customAmount"
            />
          </div>
        </div>
      </div>

      <div class="atentype" v-if="selectedAmount == 250">
        <div class="radio-part">
          <input
            id="type_Tick"
            name="Types"
            type="radio"
            :checked="getValue('custom.preK') == 'no'"
            @click="setValue('custom.preK', 'no')"
          />
          <FormLabel for="type_Tick"> Attending </FormLabel>
        </div>

        <div class="radio-part">
          <input
            name="Types"
            id="type_Journal"
            type="radio"
            :checked="getValue('custom.preK') == 'journal'"
            @click="setValue('custom.preK', 'journal')"
          />
          <FormLabel for="type_Journal"> Journal </FormLabel>
        </div>
      </div>
      <div
        class="amount-row tickets-num"
        v-if="selectedAmount == 250 && getValue('custom.preK') !== 'journal'"
      >
        <input
          id="ticketsQnt"
          type="number"
          min="1"
          name="ticketsQnt"
          placeholder="Number of tickets"
          v-model="ticketsQnt"
          @change="customQnt = true"
        />
      </div>
      <p class="note">
        * All sponsors $5,000 will be listed in the
        <a href="https://www.ou.org/benefactor/" target="_blank" style="color: #06346b"
          >OU Benefactor Circle</a
        >. Donors of $1,800 or more will be listed in
        <a
          href="https://teachcoalition.org/leadershipcircle/"
          style="color: #06346b"
          target="_blank"
          >Teach NYS Leadership Circle</a
        >.
      </p>
      <br />
      <p class="note">
        If you are a current 2023 Leadership Circle Member - Please reach out to
        <a style="color: #00346b" href="tel: (551)-336-443">(551) 336-443</a> or email
        <a style="color: #00346b" href="mailto:teachnys@teachcoalition.org"
          >teachnys@teachcoalition.org</a
        >
      </p>
      <ErrorLabel field="amount" />
    </FormSection>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const ticketsQnt = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const customQnt = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;
        customAmount.value = null;
        if (ticketsQnt.value > 0 && (selectedAmount === 250 || selectedAmount === 180)) {
          setValue("amount", "" + selectedAmount * ticketsQnt.value);
        } else {
          setValue("amount", "" + selectedAmount);
        }
      }
    });
    watch(customQnt, () => {
      customQnt.value = false;
      if (ticketsQnt) {
        setValue("amount", "" + selectedAmount.value * ticketsQnt.value);
        setValue("custom.ticketsQnt", ticketsQnt.value);
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      clearOutSelectedValue,
      customSelected,
      customQnt,
      setValue,
      getValue,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;

  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 0px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.teach-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  padding: 12px 5px;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
::v-deep.label__wrapper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
  font-size: 20px;

  span {
    font-style: italic;
    font-size: 16px;
  }
}
.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}
.atentype {
  padding-bottom: 20px;
}
</style>
